import React, { useState, useCallback, createContext, useContext, useEffect } from 'react';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'info') => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 4000);
  }, []);

  const toast = {
    success: (msg) => addToast(msg, 'success'),
    error: (msg) => addToast(msg, 'error'),
    info: (msg) => addToast(msg, 'info'),
  };

  // Override window.alert globally so all existing alert() calls become toasts
  useEffect(() => {
    const origAlert = window.alert;
    window.alert = (msg) => {
      const str = String(msg);
      if (str.toLowerCase().startsWith('error')) addToast(str, 'error');
      else if (str.toLowerCase().includes('created') || str.toLowerCase().includes('sent') || str.toLowerCase().includes('saved') || str.toLowerCase().includes('success')) addToast(str, 'success');
      else addToast(str, 'info');
    };
    return () => { window.alert = origAlert; };
  }, [addToast]);

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div style={{ position:'fixed', top: 60, right: 16, zIndex: 9999, display:'flex', flexDirection:'column', gap:8, maxWidth: 360, pointerEvents:'none' }}>
        {toasts.map(t => (
          <div key={t.id}
            style={{
              padding:'14px 18px', borderRadius:12, pointerEvents:'auto',
              background: t.type === 'success' ? '#16a34a' : t.type === 'error' ? '#dc2626' : '#1E40AF',
              color:'#fff', fontFamily:'inherit', fontSize:13, fontWeight:700,
              boxShadow:'0 8px 24px rgba(0,0,0,0.3)',
              animation:'toastIn 0.3s ease-out',
              display:'flex', alignItems:'center', gap:10, lineHeight:1.4,
            }}>
            <i className={`fa-solid ${t.type === 'success' ? 'fa-check-circle' : t.type === 'error' ? 'fa-circle-exclamation' : 'fa-circle-info'}`} style={{ fontSize:15, flexShrink:0 }}></i>
            <span style={{ flex:1 }}>{t.message}</span>
            <button onClick={() => setToasts(prev => prev.filter(x => x.id !== t.id))}
              style={{ background:'none', border:'none', color:'rgba(255,255,255,0.6)', cursor:'pointer', fontSize:14, padding:'0 0 0 4px', flexShrink:0 }}>
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
        ))}
      </div>
      <style>{`@keyframes toastIn { from { opacity:0; transform:translateX(40px); } to { opacity:1; transform:translateX(0); } }`}</style>
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
